import { useQuery } from "@tanstack/react-query"
import { fetchCompetencias } from "../api"

interface Props {
    selecionada: string
    // O texto da pílula para o mês aberto na tela; sem ele (mês ainda carregando) vale o da lista.
    rotulo?: string
    onEscolher: (referencia: string) => void
}

const PILULA = "rounded-full bg-brand-strong px-3 py-1.5 font-mono text-xs text-brand-ink"

export const SeletorCompetencia = ({ selecionada, rotulo, onEscolher }: Props) => {
    const { data } = useQuery({ queryKey: ["competencias"], queryFn: fetchCompetencias })

    if (!data?.some((competencia) => competencia.referencia !== selecionada)) {
        return rotulo ? <span className={PILULA}>{rotulo}</span> : null
    }

    const opcoes = data.some((competencia) => competencia.referencia === selecionada)
        ? data
        : [{ referencia: selecionada, rotulo: rotulo ?? selecionada }, ...data]

    return (
        <span className="relative inline-flex">
            <select
                aria-label="Competência"
                value={selecionada}
                onChange={(evento) => onEscolher(evento.target.value)}
                className={`${PILULA} cursor-pointer appearance-none pr-8 focus-visible:outline-2 focus-visible:outline-brand-ink focus-visible:outline-offset-2`}
            >
                {opcoes.map((competencia) => (
                    <option
                        key={competencia.referencia}
                        value={competencia.referencia}
                        className="bg-card font-sans text-ink"
                    >
                        {(competencia.referencia === selecionada && rotulo) || competencia.rotulo}
                    </option>
                ))}
            </select>
            <svg
                aria-hidden="true"
                viewBox="0 0 16 16"
                className="pointer-events-none absolute right-3 top-1/2 size-3 -translate-y-1/2 text-brand-ink"
            >
                <path
                    d="M4 6l4 4 4-4"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        </span>
    )
}
